import { render } from "./Whatsapp.vue?vue&type=template&id=4093f550"
const script = {}

import "./Whatsapp.vue?vue&type=style&index=0&id=4093f550&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__